import React from 'react'
import userbase from 'userbase-js'
import { Link } from 'react-router-dom'
import { ButtonLinkSmall, ButtonSmall } from './buttons'
import { useLocation } from 'react-router-dom'

export const Header = ({ user, setUser, ready }) => {
  const location = useLocation()

  const isLoginPage = location.pathname === '/login'
  let linkUrl = isLoginPage ? '/register' : '/login'
  let linkLabel = isLoginPage ? 'Sign Up' : 'Log In'

  const handleLogout = () => {
    userbase
      .signOut()
      .then(() => setUser(undefined))
      .catch((err) => alert(err))
  }

  return (
    <header className="gradient-purple-dark text-white flex justify-between items-center px-32 h-96">
      <h1 className="text-22">
        <Link to="/" className="text-white no-underline p-12">
          Bubbel
        </Link>
      </h1>
      {ready &&
        (user ? (
          <nav className="flex items-center">
            <Link
              className="hidden sm:block text-16 font-bold text-white no-underline p-12 mr-20"
              to="/"
            >
              My Bubble
            </Link>
            <Link
              className="hidden sm:block text-16 font-bold text-white no-underline p-12 mr-32"
              to="/feed"
            >
              My Recent Activity
            </Link>
            <ButtonSmall
              onClick={handleLogout}
              className="border-2 border-white text-white rounded-10"
            >
              Log Out
            </ButtonSmall>
          </nav>
        ) : (
          <ButtonLinkSmall
            to={linkUrl}
            className="border-2 border-white text-white rounded-10"
          >
            {linkLabel}
          </ButtonLinkSmall>
        ))}
    </header>
  )
}
